var map = {
	"./App.png": 212,
	"./Group 253.svg": 239,
	"./Logo.png": 216,
	"./Web.png": 240,
	"./addAcc.svg": 241,
	"./addbutton.png": 222,
	"./aldemat_navicon-light.svg": 242,
	"./aldemat_navicon.svg": 243,
	"./arrow.png": 244,
	"./bulkUpload/bulk_icon.svg": 245,
	"./bulkUpload/cancel_icon.svg": 246,
	"./bulkUpload/failed_icon.svg": 247,
	"./bulkUpload/point_icon.svg": 248,
	"./bulkUpload/status_title_icon.svg": 249,
	"./bulkUpload/success_icon.svg": 250,
	"./bulkUpload/upload_icon.svg": 251,
	"./calendar_icon.svg": 252,
	"./category/addedcart-icon.svg": 253,
	"./category/addtocart-icon.svg": 254,
	"./category/calendar_icon.svg": 255,
	"./category/card-lumpsum-icon.svg": 256,
	"./category/card-sip-icon.svg": 257,
	"./category/curved-arrow-right.svg": 258,
	"./category/curved-arrow.svg": 259,
	"./category/fundcard-bg.svg": 260,
	"./category/fundsize-icon.svg": 261,
	"./category/grid-icon.svg": 262,
	"./category/info-icon.svg": 263,
	"./category/list-icon.svg": 264,
	"./category/minamt-icon.svg": 265,
	"./category/qb_cancel_icon.svg": 266,
	"./category/qb_mod_icon.svg": 267,
	"./category/qb_remove_item.svg": 268,
	"./category/return-icon.svg": 269,
	"./category/risk-icon.svg": 270,
	"./category/risk-veryhigh.png": 271,
	"./category/search-icon.svg": 272,
	"./category/shopping-bag.svg": 273,
	"./client.png": 213,
	"./client_info_mail_icon.svg": 274,
	"./clientlist/additional_purchase_icon.svg": 275,
	"./clientlist/bar.svg": 276,
	"./clientlist/clientslist-icon.svg": 277,
	"./clientlist/coin-light.svg": 278,
	"./clientlist/coin.svg": 279,
	"./clientlist/createfolio_icon.svg": 280,
	"./clientlist/dashboard-light.svg": 281,
	"./clientlist/dashboard.svg": 282,
	"./clientlist/error-light.svg": 283,
	"./clientlist/error.svg": 284,
	"./clientlist/folio-icon.svg": 285,
	"./clientlist/folio-light.svg": 286,
	"./clientlist/isip_icon.svg": 287,
	"./clientlist/kyc-light.svg": 288,
	"./clientlist/kyc.svg": 289,
	"./clientlist/minus.svg": 290,
	"./clientlist/nfo_icon.svg": 291,
	"./clientlist/nfo_title_icon.svg": 292,
	"./clientlist/plus.svg": 293,
	"./clientlist/redeem_icon.svg": 294,
	"./clientlist/stp_icon.svg": 295,
	"./clientlist/switch_icon.svg": 296,
	"./clientlist/swp_icon.svg": 297,
	"./dash/404_error.svg": 298,
	"./dash/accountstmt.svg": 299,
	"./dash/annualreturn.png": 300,
	"./dash/banner.svg": 301,
	"./dash/bar.svg": 302,
	"./dash/buymore.svg": 303,
	"./dash/calVec.svg": 304,
	"./dash/client-icon.png": 305,
	"./dash/coin-light.svg": 306,
	"./dash/coin.svg": 307,
	"./dash/currentvalue.png": 308,
	"./dash/dailygain.png": 309,
	"./dash/dash.svg": 310,
	"./dash/green.svg": 311,
	"./dash/gross-sale-icon.png": 312,
	"./dash/investment.png": 313,
	"./dash/latestActive.svg": 314,
	"./dash/minus.svg": 315,
	"./dash/orderbook.svg": 316,
	"./dash/plus.svg": 317,
	"./dash/portfolio-dnf-icon.svg": 318,
	"./dash/portfolioview.png": 319,
	"./dash/red.svg": 320,
	"./dash/redem.svg": 321,
	"./dash/redemption-icon.png": 322,
	"./dash/revenue-icon.png": 323,
	"./dash/scheduletrans.svg": 324,
	"./dash/sipUp.svg": 325,
	"./dash/total-aum-icon.png": 326,
	"./dash/totalInvestment.png": 327,
	"./dash/totalgain.png": 328,
	"./dash/transhis.svg": 329,
	"./dash/upcomming.svg": 330,
	"./dash/zbp_folio_creation_icon.svg": 331,
	"./dash/zbp_make_payment_icon.svg": 332,
	"./dash/zbp_select_fund_icon.svg": 333,
	"./dash/zero_balance_portfolio.svg": 334,
	"./dash/zero_balance_steps_icon.svg": 335,
	"./dashboard-bulk-transaction-icon-light.svg": 336,
	"./dashboard-bulk-transaction-icon.svg": 337,
	"./dashboard-initiated-history-icon.svg": 338,
	"./dashboard-investor-list-icon-light.svg": 339,
	"./dashboard-investor-list-icon.svg": 340,
	"./dashboard-new-folio-icon-light copy.svg": 341,
	"./dashboard-new-folio-icon-light.svg": 342,
	"./dashboard-new-folio-icon.svg": 343,
	"./dashboard-quick-invest-icon-light.svg": 344,
	"./dashboard-quick-invest-icon.svg": 345,
	"./dashboard-report-icon.svg": 346,
	"./ditdash/Factsheet.svg": 347,
	"./ditdash/IFA.svg": 348,
	"./ditdash/activeSIP.svg": 349,
	"./ditdash/annualreport.svg": 350,
	"./ditdash/applicationform.svg": 351,
	"./ditdash/bulb.svg": 352,
	"./ditdash/cash.svg": 353,
	"./ditdash/commission_icon.svg": 354,
	"./ditdash/icon_annualreturn.png": 355,
	"./ditdash/icon_totalgain.png": 356,
	"./ditdash/info.svg": 357,
	"./ditdash/invest_cart_icon.svg": 358,
	"./ditdash/invest_transfer_icon.svg": 359,
	"./ditdash/latestadd_icon.svg": 360,
	"./ditdash/leaflet.svg": 361,
	"./ditdash/notice_icon.svg": 362,
	"./ditdash/orderbook.svg": 363,
	"./ditdash/pre.svg": 364,
	"./ditdash/read.svg": 365,
	"./ditdash/rmperformance_icon.svg": 366,
	"./ditdash/totalbvstotalifa_graph.svg": 367,
	"./ditdash/transactionssnap_icon.svg": 368,
	"./ditdash/upSIP.svg": 369,
	"./ditdash/webinar-banner.svg": 370,
	"./favicon.ico": 371,
	"./feedback-icon-light.png": 372,
	"./feedback-icon.png": 373,
	"./goalbase_navicon-light.svg": 374,
	"./goalbase_navicon.svg": 375,
	"./invesrore.png": 376,
	"./invest_navicon copy.svg": 377,
	"./invest_navicon-light.svg": 378,
	"./invest_navicon.svg": 379,
	"./login/password_icon.png": 223,
	"./logo-mobile.webp": 220,
	"./logo.jpg": 380,
	"./logo.svg": 381,
	"./logo.webp": 221,
	"./logout.png": 382,
	"./manageac_navicon-light.svg": 383,
	"./manageac_navicon.svg": 384,
	"./managepr_navicon-light.svg": 385,
	"./managepr_navicon.svg": 386,
	"./manual-icon-light.png": 387,
	"./manual-icon.png": 388,
	"./mastercart-icon.png": 389,
	"./mf-amc-brst-logo copy.png": 390,
	"./mf-amc-brst-logo.png": 391,
	"./mf-m-min-logo.svg": 392,
	"./mnschedule_navicon-light.svg": 393,
	"./mnschedule_navicon.svg": 394,
	"./myportfolio_navicon-light.svg": 395,
	"./myportfolio_navicon.svg": 396,
	"./nav/Group 253.svg": 397,
	"./nav/aldemat_navicon-light.svg": 398,
	"./nav/aldemat_navicon.svg": 399,
	"./nav/dashboard-bulk-transaction-icon-light.svg": 400,
	"./nav/dashboard-bulk-transaction-icon.svg": 401,
	"./nav/dashboard-initiated-history-icon.svg": 402,
	"./nav/dashboard-investor-list-icon-light.svg": 403,
	"./nav/dashboard-investor-list-icon.svg": 404,
	"./nav/dashboard-new-folio-icon-light.svg": 405,
	"./nav/dashboard-new-folio-icon.svg": 406,
	"./nav/dashboard-quick-invest-icon-light.svg": 407,
	"./nav/dashboard-quick-invest-icon.svg": 408,
	"./nav/dashboard-report-icon.svg": 409,
	"./nav/feedback-icon-light.png": 410,
	"./nav/feedback-icon.png": 411,
	"./nav/goalbase_navicon-light.svg": 412,
	"./nav/goalbase_navicon.svg": 413,
	"./nav/invest_navicon-light.svg": 414,
	"./nav/invest_navicon.svg": 415,
	"./nav/manageac_navicon-light.svg": 416,
	"./nav/manageac_navicon.svg": 417,
	"./nav/managepr_navicon-light.svg": 418,
	"./nav/managepr_navicon.svg": 419,
	"./nav/manual-icon-light.png": 420,
	"./nav/manual-icon.png": 421,
	"./nav/mastercart-icon.png": 422,
	"./nav/mf-amc-brst-logo.png": 423,
	"./nav/mf-m-min-logo.svg": 424,
	"./nav/mnschedule_navicon-light.svg": 425,
	"./nav/mnschedule_navicon.svg": 426,
	"./nav/moamc-logo-new.png": 427,
	"./nav/myportfolio_navicon-light.svg": 428,
	"./nav/myportfolio_navicon.svg": 429,
	"./nav/navBanner.svg": 430,
	"./nav/orderbook_navicon-light.svg": 431,
	"./nav/orderbook_navicon.svg": 432,
	"./nav/profile-icon.png": 433,
	"./nav/redemption_navicon-light.svg": 434,
	"./nav/redemption_navicon.svg": 435,
	"./nav/report_navicon-light.svg": 436,
	"./nav/report_navicon.svg": 437,
	"./nav/smartplan_navicon-light.svg": 438,
	"./nav/smartplan_navicon.svg": 439,
	"./nav/transfer_navicon-light.svg": 440,
	"./nav/transfer_navicon.svg": 441,
	"./navBanner.svg": 442,
	"./onboarding/bg_craft.png": 443,
	"./onboarding/female-icon.png": 444,
	"./onboarding/male-icon.png": 445,
	"./onboarding/transgender-icon.png": 446,
	"./orderbook_navicon copy.svg": 447,
	"./orderbook_navicon-light.svg": 448,
	"./orderbook_navicon.svg": 449,
	"./password.png": 217,
	"./password_hide.svg": 218,
	"./plus-sign.png": 224,
	"./plusicon.png": 450,
	"./profile-icon.png": 451,
	"./redemption_navicon-light.svg": 452,
	"./redemption_navicon.svg": 453,
	"./report_navicon-light.svg": 454,
	"./report_navicon.svg": 455,
	"./search-icon.png": 456,
	"./search2.png": 457,
	"./search3.png": 458,
	"./searchicon.png": 225,
	"./showPassword.svg": 214,
	"./smartplan_navicon-light.svg": 459,
	"./smartplan_navicon.svg": 460,
	"./trader.png": 461,
	"./transfer_navicon-light.svg": 462,
	"./transfer_navicon.svg": 463,
	"./user.png": 219,
	"./viewicon2.png": 464,
	"./xls_download_icon.png": 465
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 238;